<template>
  <SogDropDownButton
    :mdi-icon="mdiIcon"
    :type="SogDropDownButtonType.Card"
    :items="items"
    style="align-self: flex-end"
    @select="onSelect"
  >
    <slot />
  </SogDropDownButton>
</template>

<script setup lang="ts">

import SogDropDownButton from "@/shared/ui/SogDropDownButton.vue";
import SogDropDownButtonItem from "@/shared/ui/types/SogDropDownButtonItem";
import {SogDropDownButtonType} from "@/shared/ui/types/SogDropDownButtonType";

interface Props {
  mdiIcon?: string
  items?: SogDropDownButtonItem[]
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const props = withDefaults(defineProps<Props>(), {
    mdiIcon: "", items: undefined
  }
)

const _emit = defineEmits<{ (e: 'select', item?: SogDropDownButtonItem): void }>()

function onSelect(item?: SogDropDownButtonItem) {
  _emit("select", item)
}


</script>

<style scoped>

</style>
